import { Form } from "react-bootstrap";
import { CrudInputModel } from "./crudInputModel";

export const CrudCheckboxInput = ({
  validationSchema,
  form,
  name,
  label,
  disabled,
  t,
}: CrudInputModel) => {
  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        return (
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id={field.name}
              key={field.name}
              name={field.name}
              label={label}
              checked={field.state.value as boolean}
              onBlur={field.handleBlur}
              onChange={(e) => field.handleChange(e.target.checked)}
              isInvalid={field.state.meta.errors.length > 0}
              disabled={disabled}
            />
            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
};
